<template>
  <a-card :bordered="false">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" size="small" :label-col="labelCol1" :wrapper-col="wrapperCol1"
          :rules="validatorRules" slot="detail">
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label="this.language['cs.areacode']" prop="areacode">
                <a-input v-model="model.areacode" :placeholder="this.language['cs.areacode']" :maxLength="20"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="this.language['cs.areaname']" prop="areaname">
                <a-input v-model="model.areaname" :placeholder="this.language['cs.areaname']" :maxLength="100"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="this.language['cs.maxrowqty']" prop="maxRowQty">
                <a-input-number v-model="model.maxRowQty" :min="1"
                  :placeholder="this.language['cs.maxrowqty']"></a-input-number>
              </a-form-model-item>
              <a-form-model-item :label="this.language['cs.maxcolqty']" prop="maxColQty">
                <a-input-number v-model="model.maxColQty" :min="1"
                  :placeholder="this.language['cs.maxcolqty']"></a-input-number>
              </a-form-model-item>
              <!-- <a-form-model-item :label="this.language['cs.corridorposition']" prop="aisle">
              <a-input v-model="model.aisle" :placeholder="this.language['cs.corridorposition']"></a-input>
            </a-form-model-item> -->
              <!-- <a-form-model-item :label="this.language['cs.areastyle']" prop="areacolor">
              <a-input v-model="model.areacolor" :placeholder="this.language['cs.areastyle']"></a-input>
            </a-form-model-item> -->
              <!-- <a-form-model-item :label="this.language['cs.isseatsame']" prop="issameseat">
              <j-dict-select-tag type="select" v-model="model.issameseat" dictCode="cs_isSameSeats" />
            </a-form-model-item>
            <a-form-model-item :label="this.language['cs.seatcountsame']" prop="sameseatqty">
              <a-input-number  v-model="model.sameseatqty" :min="1" :placeholder="this.language['cs.seatcountsame']"></a-input-number>
            </a-form-model-item> -->
              <a-form-model-item :label="this.language['common.sort']" prop="sort">
                <a-input-number v-model="model.sort" :min="1"
                  :placeholder="this.language['common.sort']"></a-input-number>
              </a-form-model-item>
              <!-- 上傳附件圖片 -->
              <a-form-model-item :label="this.language['common.uploadPicture']" :labelCol="labelCol1"
                :wrapperCol="wrapperCol1" prop="files">
                <j-image-upload class="avatar-uploader" text="上传" :upload-source="uploadSource" v-model="model.files"
                  :isMultiple="true" :disabled="disableSubmit"></j-image-upload>
              </a-form-model-item>

            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </a-card>
</template>
  
  
<script>

import { validateDuplicateValue } from '@/utils/util'
import { httpAction, getAction } from '@/api/manageChooseSeat'
import moment from 'moment'

export default {
  name: 'AreaForm',
  components: {},
  props: {
    //表单禁用
    parent: {
      type: Object,
      default: {}
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {},
      uploadSource: "chooseseat",
      // form 一行布局
      labelCol1: { span: 6 },
      wrapperCol1: { span: 16 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
      confirmLoading: false,
      url: {
        add: "/VenueArea/addData",
        edit: "/VenueArea/editData"
      },
      selectActivityList: [],
      selectPgList: [],
      selectVenueList: []
    }
  },
  props: {
    //调用父页面
    from: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      if (this.language) {
        return {
          areacode: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.areacode'] },
          ],
          areaname: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.areaname'] },
          ],
          maxRowQty: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.maxrowqty'] },
          ],
          maxColQty: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.maxcolqty'] },
          ],
          sort: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['common.sort'] },
          ]

        }
      }
    }

  },
  created() {

    if(this.from!="VenueList")
    {
      this.url.add="/ActivityArea/addData";
      this.url.edit= "/ActivityArea/editData"
    }
  },
  mounted() {
  },
  watch: {

  },
  methods: {

    add() {
      this.visible = true;
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
    },

    submitForm() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {

        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!that.model.sysareaid) {
            httpurl += that.url.add;
            method = 'post';
          } else {
            httpurl += that.url.edit;
            method = 'put';
          }
          httpAction(httpurl, that.model, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },

  }
}


</script>